import { type DonationModel } from '@/shared/api'
import { formatDateTimeStringToDateString } from '@/shared/lib/form-utils'
import { kopeykaToRuble } from '@/shared/lib/math'
import { Button, type TableProps, Tag } from 'antd'

import { COLUMN_WIDTH } from '../../lib/column-width'
import { type DonationsByDateSortState } from '../../lib/donations-by-date-model'

interface UseDonationsByDateTableColumnsProps {
  sort: DonationsByDateSortState
  handleDetails: (id?: string | null) => void
}

export const useDonationsByDateTableColumns = ({
  sort,
  handleDetails,
}: UseDonationsByDateTableColumnsProps): TableProps<DonationModel>['columns'] => {
  return [
    {
      title: 'Пользователь',
      dataIndex: 'nickname',
      key: 'nickname',
      sorter: true,
      ellipsis: true,
      sortOrder:
        sort.field === 'nickname'
          ? sort.order === 'asc'
            ? 'ascend'
            : sort.order === 'desc'
              ? 'descend'
              : null
          : null,
      render: (_, data) => data.nickname || <Tag>Аккаунт удален</Tag>,
    },
    {
      title: 'Сумма (руб.)',
      width: COLUMN_WIDTH.AMOUNT,
      dataIndex: 'amount',
      key: 'amount',
      sorter: true,
      ellipsis: true,
      sortOrder:
        sort.field === 'amount'
          ? sort.order === 'asc'
            ? 'ascend'
            : sort.order === 'desc'
              ? 'descend'
              : null
          : null,
      render: (_, data) => kopeykaToRuble(data.amount),
    },
    {
      title: 'Дата',
      width: COLUMN_WIDTH.DATE,
      dataIndex: 'date',
      key: 'date',
      sorter: true,
      sortOrder:
        sort.field === 'date'
          ? sort.order === 'asc'
            ? 'ascend'
            : sort.order === 'desc'
              ? 'descend'
              : null
          : null,
      render: (_, data) => formatDateTimeStringToDateString(data.date),
    },
    {
      title: '',
      dataIndex: 'actions',
      key: 'actions',
      width: COLUMN_WIDTH.ACTIONS,
      align: 'center',
      render: (_, data) => (
        <Button
          disabled={!data.userId}
          variant="link"
          color="primary"
          onClick={() => {
            handleDetails(data.userId)
          }}
        >
          Подробнее
        </Button>
      ),
    },
  ]
}
